<!--
 * @Description: 基本资料
 * @Autor: lwq
 * @Date: 2020-07-17 14:23:02
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-15 18:12:28
 * @FilePath: \mrc-base-server-view\src\views\admin_account_manage\modules\baseInfo.vue
-->
<template>
  <v-card class="pa-0" :elevation="0">
    <v-card-text>
      <v-row v-if="$store.state.uuid">
        <v-col class="d-flex" cols="12" sm="3">
          <mrc_ess_switch
            :true-value="1"
            :false-value="0"
            v-model="params.status"
            :true-text="$t('label_To_enable_the')"
            :readonly="(params.uuid && Boolean(params.staffs_uuid)) || disabled"
            :false-text="$t('label_disable')"
          ></mrc_ess_switch>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="d-flex" :sm="params.uuid ? 6 : 12">
          <!-- .concat(nocharacter) -->
          <mrc_ess_multiText
            :label="$t('label_The_login_name') + '*'"
            :error-messages="
              $errors(
                'params',
                'user_account',
                requiredRule.concat(maxLength(40))
              )
            "
            :readonly="disabled"
            :disabled="Boolean(params.staffs_uuid)"
            v-model.trim="params.user_account"
            style="width:100%"
            :isNational="judegNational('user_account')"
            :placeholder="$t('label_The_login_name')"
          ></mrc_ess_multiText>
        </v-col>
        <v-col cols="12" class="d-flex flex-column " sm="6">
          <!-- {{(params.uuid)}}-----{{(params.staffs_uuid)}}---{{Boolean(params.staffs_uuid)}} -->
          <!-- :disabled="Boolean(params.uuid) || Boolean(params.staffs_uuid)" -->
          <mrc_ess_input
            :label="$t('label_password') + '*'"
            :type="passwordType"
            :append-icon="params.uuid ? '' : icon"
            @click:append="showPassword"
            @input="$v.params.user_pwd.$touch()"
            @blur="$v.params.user_pwd.$touch()"
            v-model.trim="params.user_pwd"
            :placeholder="$t('label_password')"
            :readonly="disabled"
            :disabled="
              params.staffs_uuid
                ? Boolean(params.staffs_uuid)
                : Boolean(params.uuid)
            "
            :error-messages="$errors('params', 'user_pwd', requiredRule)"
          ></mrc_ess_input>
          <span
            v-if="params.uuid && !Boolean(params.staffs_uuid)"
            @click="disabled && resetPassword()"
            class="mt-n4"
            :style="{
              color: $vuetify.theme.defaults.light.primary,
              position: 'relative',
              cursor: 'pointer',
            }"
            >{{ $t("label_To_reset_your_password") }}</span
          >
        </v-col>
        <v-col cols="12" v-if="!params.uuid" class="d-flex flex-column" sm="6">
          <!-- :readonly="Boolean(params.staffs_uuid) || Boolean(params.uuid)" -->
          <mrc_ess_input
            :label="$t('label_Confirm_password') + '*'"
            :type="passwordType"
            :append-icon="params.uuid ? '' : icon"
            @click:append="showPassword"
            @input="$v.params.confirmPassword.$touch()"
            @blur="$v.params.confirmPassword.$touch()"
            v-model.trim="params.confirmPassword"
            :placeholder="$t('label_Confirm_password')"
            :readonly="disabled"
            :disabled="
              params.staffs_uuid
                ? Boolean(params.staffs_uuid)
                : Boolean(params.uuid)
            "
            :error-messages="
              $errors(
                'params',
                'confirmPassword',
                requiredRule.concat(sameAsKey($t('label_password')))
              )
            "
          ></mrc_ess_input>
        </v-col>
        <!-- 邮箱 -->
        <v-col cols="12" class="d-flex" sm="12">
          <mrc_ess_multiText
            :label="$t('label_Mailbox') + '*'"
            :error-messages="
              $errors(
                'params',
                'user_primary_email',
                requiredRule.concat(emailRule)
              )
            "
            v-model.trim="params.user_primary_email"
            style="width:100%"
            :isNational="judegNational('user_primary_email')"
            :readonly="disabled"
            :disabled="Boolean(params.staffs_uuid)"
            :placeholder="$t('label_Mailbox')"
          ></mrc_ess_multiText>
        </v-col>
        <!-- 关联客户 -->
        <v-col md="12">
          <mrc_ess_autoComplete
            @changeStaffList="clientUUIDChange"
            :label="$t('label_associated_customers') + '*'"
            :error-messages="$errors('params', 'clients_uuid', requiredRule)"
            :readonly="disabled"
            :disabled="
              params.manager_type == 3 ||
                (params.uuid && Boolean(params.staffs_uuid))
            "
            v-model="params.clients_uuid"
            prompt_name="administrator_client"
          >
          </mrc_ess_autoComplete>
        </v-col>
        <!-- 关联单位要根据关联客户来筛选 -->
        <v-col md="12">
          <mrc_ess_autoComplete
            :dropDownList="client_levels_arr"
            multiple
            @changeStaffList="getSelectClients"
            :label="$t('label_Associated_with_the_unit') + '*'"
            :error-messages="$errors('params', 'org_level_uuid', requiredRule)"
            :readonly="disabled"
            :disabled="
              params.manager_type == '3' ||
                (params.uuid && Boolean(params.staffs_uuid))
            "
            v-model="params.org_level_uuid"
          >
          </mrc_ess_autoComplete>
        </v-col>
        <!-- <v-col cols="12" class="d-flex" sm="3" v-if="hasStaff">
          <v-checkbox
            dense
            :disabled="(params.uuid && Boolean(params.staffs_uuid)) || disabled"
            @change="isBindStaffChange"
            v-model="isBindStaff"
            :label="$t('label_Binding_employees')"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="9" class="py-0" v-show="hasStaff">
          <mrc_ess_autoComplete
            :dropDownList="bindStaffList"
            @changeStaff="getStaffUUid"
            @changeStaffList="getSelectItem"
            :label="$t('label_Binding_employees')"
            :readonly="disabled"
            :disabled="
              params.manager_type == '3' ||
                (params.uuid && Boolean(params.staffs_uuid))
            "
            v-model="params.staffs_uuid"
          >
          </mrc_ess_autoComplete>
        </v-col> -->
      </v-row>
    </v-card-text>
    <mrc_ess_submitBtn
      @cancel="cancel"
      v-if="!disabled"
      :loading="loading"
      @success="success"
      :cancelText="cancelText || $t('label_cancel')"
      :successText="successText || $t('label_submit')"
    ></mrc_ess_submitBtn>
  </v-card>
</template>

<script>
import { required, email, maxLength, sameAs } from "vuelidate/lib/validators"
import {
  admin_account_reset,
  takeout_customer,
} from "@/service/api/admin_account_manage"
import { getBusinessList } from "@/service/api/prompt"
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
    },
    successText: {
      type: String,
    },
    paramsData: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      passwordType: "password",
      hasStaff: false,
      icon: "mdi-eye-off",
      isBindStaff: false,
      params: {
        status: 1,
        user_account: "",
        user_pwd: "",
        user_primary_email: "",
        org_level_uuid: "",
        confirmPassword: "",
        staffs_uuid: "",
        clients_uuid: "",
        manager_type: "",
      },
      client_levels_arr: [],
      bindStaffList: [],
    }
  },
  validations: {
    params: {
      confirmPassword: {
        required(val) {
          if (this.params.uuid) return true
          else return val.length > 0
        },
        sameAsKey(val) {
          if (this.params.uuid) return true
          else return val == this.params.user_pwd
        },
      },
      user_account: {
        required,
        maxLength: maxLength(40),
        // nocharacter(value) {
        //   return this.$myVerify.nocharacter(this.INT(value))
        // },
      },
      user_pwd: {
        required,
      },
      user_primary_email: {
        required,
        email,
      },
      org_level_uuid: {
        required,
      },
      clients_uuid: {
        required,
      },
    },
  },
  computed: {
    computed_org_level_uuid: {
      get() {
        if (this.params.org_level_uuid) {
          return this.params.org_level_uuid.indexOf(",") > -1
            ? this.params.org_level_uuid.split(",")
            : [this.params.org_level_uuid]
        } else {
          return []
        }
      },
      set(val) {
        this.params.org_level_uuid = val.join()
      },
    },
  },
  watch: {
    paramsData: {
      async handler(val) {
        this.params = val
        if (this.params.uuid) {
          if (this.params.staffs_uuid) {
            this.hasStaff = true
            this.isBindStaff = true
            await this.getPrompt()
          } else {
            this.hasStaff = false
            this.isBindStaff = false
          }
        } else {
          this.hasStaff = true
          this.isBindStaff = false
        }
        // this.params.staffs_uuid ? this.isBindStaff = true : this.isBindStaff = false
      },
      deep: true,
    },
    "params.staffs_uuid"(val) {
      if (val) {
        this.isBindStaff = true
      } else {
      }
    },
    // 'params.org_level_uuid': {
    //   async handler(val) {
    //     if (val) {
    //       this.params.staffs_uuid = ''
    //       await this.getPrompt()
    //     } else {
    //       if (this.params.staffs_uuid) {
    //         this.params.user_account = ''
    //         this.params.user_pwd = ''
    //         this.params.confirmPassword = ''
    //         this.params.user_primary_email = ''
    //         this.$v.params.$reset()
    //       }
    //       this.params.staffs_uuid = ''

    //       this.bindStaffList = []
    //     }
    //   },
    //   immediate: true,
    // },
  },
  async created() {
    await this.national("mrbase_sys_users")
    if (this.paramsData) {
      this.params = this.paramsData
      if (this.params.staffs_uuid) {
        await this.getPrompt()
        this.hasStaff = true
        this.isBindStaff = true
      } else {
        this.hasStaff = false
        this.isBindStaff = false
      }

      if (this.params.clients_uuid) {
        await this.getOrgLevelUUID()
      }
    } else {
      this.hasStaff = true
      this.isBindStaff = false
    }
  },
  mounted() {},

  methods: {
    showPassword() {
      if (this.passwordType == "password") {
        this.icon = "mdi-eye"
        this.passwordType = "text"
      } else {
        this.icon = "mdi-eye-off"
        this.passwordType = "password"
      }
    },
    // 切换客户的时候 重置单位和员工 并清除之前员工的账号等带入信息
    async clientUUIDChange(val) {
      this.params.org_level_uuid = ""
      this.params.staffs_uuid = ""
      this.bindStaffList = []
      if (this.params.staffs_uuid) {
        this.params.user_account = ""
        this.params.user_pwd = ""
        this.params.confirmPassword = ""
        this.params.user_primary_email = ""
        this.$v.params.$reset()
      }
      // 如果有客户才去请求关联单位
      if (this.params.clients_uuid) {
        await this.getOrgLevelUUID()
      } else {
        this.client_levels_arr = []
      }
    },
    // 获取关联单位
    async getOrgLevelUUID() {
      try {
        const res = await getBusinessList({
          prompt_name: "client_levels",
          client_uuid: this.params.clients_uuid,
        })
        if (res.code == 200) {
          this.client_levels_arr = res.data
        } else {
          this.client_levels_arr = []
        }
      } catch (err) {
        this.client_levels_arr = []
      }
    },
    async getSelectClients(val) {
      let org_level_uuid = val.map((item) => item.value_field).join()
      if (org_level_uuid) {
        this.params.staffs_uuid = ""
        // await this.getPrompt()
        const res = await getBusinessList({
          prompt_name: "levels-staffs-not-valid",
          org_level_uuid: org_level_uuid
            ? org_level_uuid.replace(",", "','")
            : "",
          staffs_uuid: this.params.staffs_uuid,
        })
        if (res.code == 200) {
          this.bindStaffList = res.data
        }
      } else {
        if (this.params.staffs_uuid) {
          this.params.user_account = ""
          this.params.user_pwd = ""
          this.params.confirmPassword = ""
          this.params.user_primary_email = ""
          this.$v.params.$reset()
        }
        this.params.staffs_uuid = ""

        this.bindStaffList = []
      }
    },
    isBindStaffChange(val) {
      // 选了员工再不勾选才会重置这些信息
      if (!val) {
        if (this.params.staffs_uuid) {
          this.params.user_account = ""
          this.params.user_pwd = ""
          this.params.confirmPassword = ""
          this.params.user_primary_email = ""
          this.params.staffs_uuid = ""
          this.$v.params.$reset()
        }
      }
    },
    // 如果不选员工那么就重置
    getStaffUUid(val) {
      if (!val) {
        this.params.user_account = ""
        this.params.user_pwd = ""
        this.params.confirmPassword = ""
        this.params.user_primary_email = ""
        this.params.staffs_uuid = ""
        // this.params.clients_uuid = ''
        // this.params.org_level_uuid = ''
        this.params.user_primary_email = ""
        this.$v.params.$reset()
      }
    },
    // 选了员工调接口获取所选员工的账户信息
    async getSelectItem(val) {
      try {
        const res = await takeout_customer({ uuid: val.value_field })
        if (res.code == 200) {
          this.params.user_account = res.data.user_account || ""
          this.params.user_pwd = res.data.user_pwd || ""
          this.params.confirmPassword = res.data.user_pwd || ""
          this.params.user_primary_email = res.data.user_primary_email || ""
        } else {
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 获取员工
    async getPrompt() {
      const res = await getBusinessList({
        prompt_name: "levels-staffs-not-valid",
        org_level_uuid: this.params.org_level_uuid
          ? this.params.org_level_uuid.replace(",", "','")
          : "",
        staffs_uuid: this.params.staffs_uuid,
      })
      if (res.code == 200) {
        this.bindStaffList = res.data
      }
    },
    success() {
      this.$v.params.$touch()
      if (this.$v.params.$error) return
      if (!this.isBindStaff) {
        this.params.staffs_uuid = ""
      }
      this.$emit("success", this.params)
    },
    cancel() {
      this.$emit("cancel")
    },
    async resetPassword() {
      const reset = await admin_account_reset({
        uuid: this.params.uuid,
        login_url: this.$store.state.loginUrl,
      })
      if (reset.code == 200) {
        this.$Message({ text: this.$t("message_The_operation_was_successful") })
      }
    },
  },
}
</script>

<style scoped></style>
